import { TDR } from 'tdr-common';
import { isEventVisibleForCard } from './isEventVisibleForCard';

/**
 * Filter the restaurant's full event list down to those that should appear on
 * the results page: every upcoming event that passes `isEventVisibleForCard`.
 */
export function filterEventsForSearchFilters(events: TDR.Event[]): TDR.Event[] {
	if (!events?.length) {
		return [];
	}

	return events.filter(isEventVisibleForCard);
}
